<template>
  <div class="phone">
    <p class="phone__label">
      Zostaw numer telefonu, a wyślemy Ci SMS<br />
      gdy naprawa będzie gotowa.
    </p>

    <form class="field" @submit.prevent="submit">
      <input
        type="tel"
        inputmode="numeric"
        class="field__input"
        placeholder="+48 600 000 000"
        :value="phoneNumber"
        @input="onInput"
      />
      <button
        type="submit"
        class="field__btn"
        :class="{ 'field__btn--active': isValid }"
        :disabled="!isValid"
        aria-label="Zapisz numer"
      >
        <svg viewBox="0 0 24 24" class="icon" aria-hidden="true">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>
    </form>

    <p class="phone__rodo">
      Podając numer telefonu zgadzasz się na otrzymanie informacji o zakończeniu
      naprawy. Twoje dane przetwarzamy zgodnie z obowiązkiem informacyjnym, z
      którym zapoznałeś się przy oddaniu auta do serwisu.
    </p>

    <transition name="modal">
      <div v-if="success" class="modal" @click.self="success = false">
        <div class="modal__card">
          <button
            class="modal__close"
            @click="success = false"
            aria-label="Zamknij"
          >
            <svg viewBox="0 0 24 24" class="icon">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <div class="modal__icon modal__icon--ok">
            <svg viewBox="0 0 24 24" class="icon">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <p class="modal__msg">
            Zapisaliśmy Twój numer. Wyślemy SMS, gdy naprawa będzie gotowa.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DetailsPhone",
  data() {
    return {
      phoneNumber: "",
      digits: "",
      success: false,
    };
  },
  computed: {
    isValid() {
      return this.digits.length === 9;
    },
  },
  methods: {
    ...mapActions(["addPhoneNumber"]),
    onInput(e) {
      let d = e.target.value.replace(/\D/g, "");
      if (d.startsWith("48")) d = d.slice(2);
      d = d.slice(0, 9);
      this.digits = d;
      const groups = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9)].filter(
        Boolean
      );
      this.phoneNumber = d.length ? "+48 " + groups.join(" ") : "";
    },
    submit() {
      if (!this.isValid) return;
      this.addPhoneNumber(this.phoneNumber).then(() => {
        this.success = true;
        this.phoneNumber = "";
        this.digits = "";
      });
    },
  },
};
</script>
